// Geolocation and Currency Detection Utilities

// Country to Currency mapping
const COUNTRY_CURRENCY_MAP = {
  'US': 'USD',
  'CA': 'CAD',
  'GB': 'GBP',
  'EU': 'EUR',
  'DE': 'EUR',
  'FR': 'EUR',
  'IT': 'EUR',
  'ES': 'EUR',
  'NL': 'EUR',
  'AU': 'AUD',
  'JP': 'JPY',
  'CN': 'CNY',
  'IN': 'INR',
  'BR': 'BRL',
  'MX': 'MXN',
  'ZA': 'ZAR',
  'NG': 'NGN',
  'KE': 'KES',
  'GH': 'GHS',
  'EG': 'EGP',
  'MA': 'MAD',
  'DZ': 'DZD',
  'TN': 'TND',
  'LY': 'LYD',
  'SD': 'SDG',
  'ET': 'ETB',
  'UG': 'UGX',
  'TZ': 'TZS',
  'ZW': 'ZWL',
  'BW': 'BWP',
  'ZM': 'ZMW',
  'MW': 'MWK',
  'MZ': 'MZN',
  'AO': 'AOA',
  'MG': 'MGA',
  'MU': 'MUR',
  'SC': 'SCR',
  'RE': 'EUR',
  'YT': 'EUR',
  'KM': 'KMF',
  'DJ': 'DJF',
  'SO': 'SOS',
  'ER': 'ERN',
  'SS': 'SSP',
  'CF': 'XAF',
  'TD': 'XAF',
  'CM': 'XAF',
  'GQ': 'XAF',
  'GA': 'XAF',
  'CG': 'XAF',
  'CD': 'CDF',
  'ST': 'STN',
  'GW': 'XOF',
  'GN': 'GNF',
  'SL': 'SLE',
  'LR': 'LRD',
  'CI': 'XOF',
  'BF': 'XOF',
  'ML': 'XOF',
  'NE': 'XOF',
  'SN': 'XOF',
  'MR': 'MRU',
  'GM': 'GMD',
  'CV': 'CVE',
  'BJ': 'XOF',
  'TG': 'XOF'
};

// Currency information with symbols and names
export const CURRENCY_INFO = {
  'USD': { symbol: '$', name: 'US Dollar', country: 'United States' },
  'EUR': { symbol: '€', name: 'Euro', country: 'European Union' },
  'GBP': { symbol: '£', name: 'British Pound', country: 'United Kingdom' },
  'CAD': { symbol: 'C$', name: 'Canadian Dollar', country: 'Canada' },
  'AUD': { symbol: 'A$', name: 'Australian Dollar', country: 'Australia' },
  'JPY': { symbol: '¥', name: 'Japanese Yen', country: 'Japan' },
  'CNY': { symbol: '¥', name: 'Chinese Yuan', country: 'China' },
  'INR': { symbol: '₹', name: 'Indian Rupee', country: 'India' },
  'BRL': { symbol: 'R$', name: 'Brazilian Real', country: 'Brazil' },
  'MXN': { symbol: '$', name: 'Mexican Peso', country: 'Mexico' },
  'ZAR': { symbol: 'R', name: 'South African Rand', country: 'South Africa' },
  'NGN': { symbol: '₦', name: 'Nigerian Naira', country: 'Nigeria' },
  'KES': { symbol: 'KSh', name: 'Kenyan Shilling', country: 'Kenya' },
  'GHS': { symbol: '₵', name: 'Ghanaian Cedi', country: 'Ghana' },
  'EGP': { symbol: 'E£', name: 'Egyptian Pound', country: 'Egypt' },
  'MAD': { symbol: 'DH', name: 'Moroccan Dirham', country: 'Morocco' },
  'DZD': { symbol: 'DA', name: 'Algerian Dinar', country: 'Algeria' },
  'TND': { symbol: 'DT', name: 'Tunisian Dinar', country: 'Tunisia' },
  'LYD': { symbol: 'LD', name: 'Libyan Dinar', country: 'Libya' },
  'SDG': { symbol: 'SDG', name: 'Sudanese Pound', country: 'Sudan' },
  'ETB': { symbol: 'Br', name: 'Ethiopian Birr', country: 'Ethiopia' },
  'UGX': { symbol: 'USh', name: 'Ugandan Shilling', country: 'Uganda' },
  'TZS': { symbol: 'TSh', name: 'Tanzanian Shilling', country: 'Tanzania' },
  'ZWL': { symbol: 'Z$', name: 'Zimbabwean Dollar', country: 'Zimbabwe' },
  'BWP': { symbol: 'P', name: 'Botswana Pula', country: 'Botswana' },
  'ZMW': { symbol: 'ZK', name: 'Zambian Kwacha', country: 'Zambia' },
  'MWK': { symbol: 'MK', name: 'Malawian Kwacha', country: 'Malawi' },
  'MZN': { symbol: 'MT', name: 'Mozambican Metical', country: 'Mozambique' },
  'AOA': { symbol: 'Kz', name: 'Angolan Kwanza', country: 'Angola' },
  'MGA': { symbol: 'Ar', name: 'Malagasy Ariary', country: 'Madagascar' },
  'MUR': { symbol: '₨', name: 'Mauritian Rupee', country: 'Mauritius' },
  'SCR': { symbol: '₨', name: 'Seychellois Rupee', country: 'Seychelles' },
  'KMF': { symbol: 'CF', name: 'Comorian Franc', country: 'Comoros' },
  'DJF': { symbol: 'Fdj', name: 'Djiboutian Franc', country: 'Djibouti' },
  'SOS': { symbol: 'S', name: 'Somali Shilling', country: 'Somalia' },
  'ERN': { symbol: 'Nfk', name: 'Eritrean Nakfa', country: 'Eritrea' },
  'SSP': { symbol: 'SSP', name: 'South Sudanese Pound', country: 'South Sudan' },
  'XAF': { symbol: 'FCFA', name: 'Central African CFA Franc', country: 'Central Africa' },
  'CDF': { symbol: 'FC', name: 'Congolese Franc', country: 'Democratic Republic of Congo' },
  'STN': { symbol: 'Db', name: 'São Tomé Dobra', country: 'São Tomé and Príncipe' },
  'XOF': { symbol: 'CFA', name: 'West African CFA Franc', country: 'West Africa' },
  'GNF': { symbol: 'FG', name: 'Guinean Franc', country: 'Guinea' },
  'SLE': { symbol: 'Le', name: 'Sierra Leonean Leone', country: 'Sierra Leone' },
  'LRD': { symbol: 'L$', name: 'Liberian Dollar', country: 'Liberia' },
  'MRU': { symbol: 'UM', name: 'Mauritanian Ouguiya', country: 'Mauritania' },
  'GMD': { symbol: 'D', name: 'Gambian Dalasi', country: 'Gambia' },
  'CVE': { symbol: '$', name: 'Cape Verdean Escudo', country: 'Cape Verde' }
};

// Get user's location using browser geolocation API
export const getUserLocation = () => {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      reject(new Error('Geolocation is not supported by this browser'));
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        resolve({
          latitude: position.coords.latitude,
          longitude: position.coords.longitude
        });
      },
      (error) => {
        reject(error);
      },
      {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 300000 // 5 minutes
      }
    );
  });
};

// Get country from coordinates using reverse geocoding
export const getCountryFromCoordinates = async (latitude, longitude) => {
  try {
    // Using a free reverse geocoding service
    const response = await fetch(
      `https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=${latitude}&longitude=${longitude}&localityLanguage=en`
    );
    const data = await response.json();
    return data.countryCode;
  } catch (error) {
    console.error('Error getting country from coordinates:', error);
    return null;
  }
};

// Get currency from country code
export const getCurrencyFromCountry = (countryCode) => {
  return COUNTRY_CURRENCY_MAP[countryCode] || 'USD'; // Default to USD
};

// Detect user's currency based on location
export const detectUserCurrency = async () => {
  try {
    // First try to get location from IP (faster, doesn't require permission)
    const ipResponse = await fetch('https://ipapi.co/json/', {
      mode: 'cors',
      headers: {
        'Accept': 'application/json',
      }
    });
    
    if (!ipResponse.ok) {
      throw new Error(`HTTP ${ipResponse.status}: ${ipResponse.statusText}`);
    }
    
    const ipData = await ipResponse.json();
    
    if (ipData.country_code) {
      const currency = getCurrencyFromCountry(ipData.country_code);
      return {
        currency,
        country: ipData.country_name,
        countryCode: ipData.country_code,
        method: 'ip'
      };
    }
  } catch (error) {
    console.log('IP-based detection failed:', error.message);
    // Don't try geolocation as fallback in development to avoid CORS issues
    if (process.env.NODE_ENV === 'development') {
      console.log('Skipping geolocation fallback in development mode');
      return {
        currency: 'USD',
        country: 'United States',
        countryCode: 'US',
        method: 'development-fallback'
      };
    }
  }

  try {
    // Fallback to browser geolocation (only in production)
    const location = await getUserLocation();
    const countryCode = await getCountryFromCoordinates(location.latitude, location.longitude);
    
    if (countryCode) {
      const currency = getCurrencyFromCountry(countryCode);
      return {
        currency,
        countryCode,
        method: 'geolocation'
      };
    }
  } catch (error) {
    console.log('Geolocation failed:', error.message);
  }

  // Final fallback
  return {
    currency: 'USD',
    country: 'United States',
    countryCode: 'US',
    method: 'fallback'
  };
};

// Format currency amount
export const formatCurrency = (amount, currency = 'USD') => {
  // Ensure amount is a valid number
  const numericAmount = parseFloat(amount);
  if (isNaN(numericAmount) || numericAmount < 0) {
    return '$0.00';
  }
  
  const currencyInfo = CURRENCY_INFO[currency];
  if (!currencyInfo) {
    return `$${numericAmount.toFixed(2)}`;
  }
  
  return `${currencyInfo.symbol}${numericAmount.toFixed(2)}`;
};

// Get all available currencies for selection
export const getAvailableCurrencies = () => {
  return Object.keys(CURRENCY_INFO).map(code => ({
    code,
    ...CURRENCY_INFO[code]
  }));
};
